export default Object.freeze({
  MATH_SECOND: 60,
  MATH_HOUR: 60 * 60,
  MATH_DAY: 60 * 60 * 24
})
